/**
 * G_Define.js
 *
 * @경로 : /public/scripts/game/lcPlugIn/lcCanvasGrid/dev/util/G_Define.js
 * @목적 : 그리드 게임 속성 정의 클래스 (static)
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.02.27
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Define from 'canvas/base/dev/util/B_Define'

const G_Define = (function () {
	return class {

		// @DES :: GAME_TYPE {str} - 게임타입
		static get GAME_TYPE() {
			return 'grid';
		}

		// @DES :: RATIO {num} - 가로대비 세로비율
		static get RATIO() {
			return 1;
		}

		// @DES :: SOUND_SRC {str} - 해당 부분은 상위 사용자에 의해 변경이 가능합니다.
		static get SOUND_SRC() {
			return '/codmos/static/assets/logicong-study-resources/sound/';
		}

		// @DES :: SOUND_RES {json}
		static get SOUND_RES() {
			return {
				crush: 'break.mp3',
				get: 'death.mp3',
				walk: 'shot.mp3',
				jump: 'spawn.mp3'
			}
		}

		// @DES :: POINT_PERSENT {num} - 중심값
		static get POINT_PERSENT() {
			return 50
		}

		// @DES :: ARRAY_SYSTEM {arr}
		static get ARRAY_SYSTEM() {
			return [
				'queue', // [1] 큐 타입
				'stack'  // [2] 스택 타입
			]
		}

		// @DES :: REASON {obj} - 전달 메세지
		static get REASON() {
			return Object.assign(B_Define.REASON, {

			});
		}

		// ============================ CHILD ============================

		// @DES :: PATH_TYPE {str} - path 타입
		static get PATH_TYPE() {
			return 'path'
		}

		// @DES :: GOAL_TYPE {str} - goal 타입
		static get GOAL_TYPE() {
			return 'goal'
		}

		// @DES :: INSPECTOR_TYPE {str} - inspector 타입
		static get INSPECTOR_TYPE() {
			return 'inspector'
		}

		// @DES :: GET_ITEM_TYPE {str} - get item 타입
		static get GET_ITEM_TYPE() {
			return 'getItem'
		}

		// @DES :: ACTION_ITEM_TYPE {str} - action item 타입
		static get ACTION_ITEM_TYPE() {
			return 'actionItem'
		}

		// @DES :: HIT_ITEM_TYPE {str} - hit item 타입
		static get HIT_ITEM_TYPE() {
			return 'hitItem'
		}

		// @DES :: PUSH_ITEM_TYPE {str} - push item 타입
		static get PUSH_ITEM_TYPE() {
			return 'pushItem'
		}

		// @DES :: OBSTACLE_TYPE {str} - obstacle 타입
		static get OBSTACLE_TYPE() {
			return 'obstacle'
		}

		// @DES :: BARRIER_TYPE {str} - barrier 타입
		static get BARRIER_TYPE() {
			return 'barrier'
		}

		// @DES :: PORTAL_TYPE {str} - portal 타입
		static get PORTAL_TYPE() {
			return 'portal'
		}

		// @DES :: SWITCH_TYPE {str} - switch 타입
		static get SWITCH_TYPE() {
			return 'switch'
		}

		// @DES :: HERO_TYPE {str} - hero 타입
		static get HERO_TYPE() {
			return 'hero'
		}

		// @DES :: VIRTUAL_TYPE {str} - 가상 타입
		static get VIRTUAL_TYPE() {
			return 'virtual'
		}

		// @DES :: VARIABLE_REAL_TYPE {str} - 실제 변수 (보이지 않음)
		static get VARIABLE_REAL_TYPE () { return 'variableReal' }

		// @DES :: VARIABLE_TYPE {str} - 실제 변수를 참조함 {보임}
		static get VARIABLE_TYPE () { return 'variable' }

		// @DES :: ACTION_SOLUTION_TYPE {str} - 액션을 수행한 후 참조하는 해결책 타입
		static get ACTION_SOLUTION_TYPE () { return 'actionSolution' }

		// @DES :: VARIABLE_SOLUTION_TYPE {str} - 변수의 값이 변경될 때마다 처리 되는 해결책 타입
		static get VARIABLE_SOLUTION_TYPE () { return 'variableSolution' }

		// @DES :: RESOURCE_SOLUTION_TYPE {str} - 리소스의 위치가 변경될 때마다 처리 되는 해결책 타입
		static get RESOURCE_SOLUTION_TYPE () { return 'resourceSolution' }

		// @DES :: POSITION_SOLUTION_TYPE {str} - RESOURCE_SOLUTION_TYPE과 동일하나 위치 기준으로 처리
		static get POSITION_SOLUTION_TYPE () { return 'positionSolution' }

		// @DES :: ITEM_SOLUTION_TYPE {str} - 아이템을 획득한 후 처리 되는 해결책 타입
		static get ITEM_SOLUTION_TYPE () { return 'itemSolution' }

		// @DES :: LIST {obj} - 게임 객체 종류
		static get LIST() {
			return B_Define.LIST.concat([
				G_Define.ACTION_SOLUTION_TYPE,
				G_Define.VARIABLE_SOLUTION_TYPE,
				G_Define.RESOURCE_SOLUTION_TYPE,
				G_Define.POSITION_SOLUTION_TYPE,
				G_Define.ITEM_SOLUTION_TYPE,
				G_Define.PATH_TYPE,
				G_Define.HERO_TYPE,
				G_Define.GOAL_TYPE,
				G_Define.INSPECTOR_TYPE,
				G_Define.OBSTACLE_TYPE,
				G_Define.BARRIER_TYPE,
				G_Define.HIT_ITEM_TYPE,
				G_Define.GET_ITEM_TYPE,
				G_Define.ACTION_ITEM_TYPE,
				G_Define.PUSH_ITEM_TYPE,
				G_Define.PORTAL_TYPE,
				G_Define.SWITCH_TYPE,
				G_Define.VARIABLE_REAL_TYPE,
				G_Define.VARIABLE_TYPE,
				G_Define.VIRTUAL_TYPE,
			]);
		}

		// @DES :: CRUSH_OBJECT {arr} - 충돌 객체
		static get CRUSH_OBJECT() {
			return [
				B_Define.PATH_TYPE,
				G_Define.OBSTACLE_TYPE,
				G_Define.BARRIER_TYPE,
				G_Define.PUSH_ITEM_TYPE
			];
		}

		// @DES :: CRUSH_OBJECT_IN_PUSH {arr} - 충돌 객체 (push 할때)
		static get CRUSH_OBJECT_IN_PUSH() {
			return [
				G_Define.OBSTACLE_TYPE,
				G_Define.BARRIER_TYPE,
				G_Define.PUSH_ITEM_TYPE,
				G_Define.PORTAL_TYPE,
				G_Define.SWITCH_TYPE,
				G_Define.GOAL_TYPE,
				G_Define.HIT_ITEM_TYPE,
				G_Define.GET_ITEM_TYPE,
			];
		}


		// @DES :: ORDER {arr} - 우선 순위
		static get ORDER() {
			return [
				B_Define.BG_TYPE,
				B_Define.DECO_TYPE, // 장식
				B_Define.GRID_TYPE, // 그리드
				G_Define.PATH_TYPE, // 패스
				G_Define.INSPECTOR_TYPE, // 조사자
				G_Define.OBSTACLE_TYPE, // 장애물
				G_Define.ACTION_ITEM_TYPE, // 액션-아이템
				G_Define.GET_ITEM_TYPE, // 겟-아이템
				G_Define.HIT_ITEM_TYPE, // 히트-아이템
				G_Define.PUSH_ITEM_TYPE, // 푸시-아이템
				G_Define.PORTAL_TYPE, // 포탈
				G_Define.SWITCH_TYPE, // 스위치
				G_Define.GOAL_TYPE, // 목표
				G_Define.HERO_TYPE, // 영웅
			];
		}

		// ============================ EFFECT ============================

		// @DES :: PORTAL_COLOR {arr} - 포탈 입자 색상
		static get PORTAL_COLOR() {
			return [ '#ffffff', '#bdffff', '#ffffe0' ]
		}

		// @DES :: IS_SENSOR_ANSWER_SOMETHING (OBJECT_ID, this.CODMOS) => {boolean} - 깃발(sensor)에 닿은 '$OBJECT'말고 다른게 정답이니?
		static IS_SENSOR_ANSWER_SOMETHING (THIS_OBJECT_ID, CODMOS) {
			return THIS_OBJECT_ID
				&& CODMOS.WORLD.LIST.solution.solution
				&& CODMOS.WORLD.LIST.solution.solution.answerSheet
				&& CODMOS.WORLD.LIST.solution.solution.answerSheet.inventory
				&& CODMOS.WORLD.LIST.solution.solution.answerSheet.inventory.sensor
				&& CODMOS.WORLD.LIST.solution.solution.answerSheet.inventory.sensor.objectId !== THIS_OBJECT_ID;
		}
	};
}());

export default G_Define;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/util/G_Define.js